/**
 * Public URL of the hosted RAPA MCP connector. Customers paste this into
 * Claude / ChatGPT; overridable per environment via `VITE_MCP_URL`.
 */
export const mcpUrl: string = import.meta.env.VITE_MCP_URL || 'https://mcp.rapallc.com/mcp'

/** Full connector setup guide, rendered by GitHub. */
export const MCP_DOC_URLS = {
  en: 'https://github.com/3leafcoder/rapa/blob/main/docs/mcp-setup.md',
  es: 'https://github.com/3leafcoder/rapa/blob/main/docs/mcp-setup.es.md',
} as const
